export default "__VITE_ASSET__BWl978rA__"